// components/Navbar.js
"use client"

import { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
//import "@/components/navbar.css"
import "./navbar.css";
import { FiHome, FiTrendingUp, FiShoppingCart, FiSmartphone } from 'react-icons/fi';

const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [activeTab, setActiveTab] = useState('web');
    const [showAll, setShowAll] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    // Website development services data
    const webItems = [
        { 
            title: 'e-Commerce Development', 
            description: 'Powerful online stores with secure payment gateways',
            link:"/ecommerce-website-development-services"
        },
        { 
            title: 'e-Commerce Marketplace Development', 
            description: 'Custom multi-vendor platforms for scalable online marketplaces',
            link:"/ecommerce-marketplace-website-services"
        },
        { 
            title: 'Business Website Design', 
            description: 'Bespoke designs tailored to your brand identity and business goals',
            link:"/ecommerce-website-development-services"
        },
        { 
            title: 'Personal Website Design', 
            description: 'Mobile-friendly websites that adapt seamlessly to all devices',
            link:"/personal-website-design" 
        },
        { 
            title: 'UI/UX Design', 
            description: 'Intuitive interfaces designed to maximize user engagement',
            link:"/ui-ux-design-services"
        },
        { 
            title: 'Landing Page Development', 
            description: 'High-converting pages optimized for marketing campaigns',
            link:"/landing-page-development"
        },
        { 
            title: 'WordPress & Shopify Development', 
            description: 'Custom solutions for the world\'s leading CMS and eCommerce platforms',
            link:"/wordpress-shopify-development"
        },
        { 
            title: 'Website Redesign & Modernization', 
            description: 'Transform outdated sites into high-performing digital assets',
            link:"/website-redesign-and-modernization"
        },
        { 
            title: 'Website Maintenance & Support', 
            description: 'Ongoing updates, security patches, and performance optimization',
            link:"/website-support-and-maintenance-services"
        },
    ];

    // Digital marketing services data
    const digiItems = [
        { 
            title: 'SEO (Search Engine Optimization)', 
            description: 'Increase organic visibility and climb search rankings',
            link:"/seo-services"
        },
        { 
            title: 'Social Media Marketing', 
            description: 'Strategic campaigns to grow your audience and engagement',
            link:"/social-media-marketing-services"
        },
        { 
            title: 'Social Media Optimization', 
            description: 'Profile optimization and content strategies for maximum impact',
            link:"/social-media-optimization-services"
        },
        { 
            title: 'Content Marketing', 
            description: 'Compelling content that drives traffic and conversions',
            link:"/digital-marketing-services"
        },
        { 
            title: 'Conversion Rate Optimization', 
            description: 'Data-driven improvements to boost your conversion funnel',
            link:"/digital-marketing-services"
        },
        { 
            title: 'Analytics & Reporting', 
            description: 'Actionable insights from your digital performance data',
            link:"/digital-marketing-services"
        },
        { 
            title: 'eCommerce Marketing', 
            description: 'Specialized strategies for online store growth',
            link:"/ecommerce-marketplaces-services"
        },
        { 
            title: 'Online Reputation Management', 
            description: 'Build and protect your brand\'s digital presence',
            link:"/digital-marketing-services"
        },
    ];

    // Marketplace services data
    const marketItems = [
        { 
            title: 'Amazon', 
            description: 'Complete seller account setup and optimization',
            link:"/ecommerce-marketplaces-services"
        },
        { 
            title: 'Flipkart', 
            description: 'End-to-end marketplace management solutions',
            link:"/ecommerce-marketplaces-services"
        },
        { 
            title: 'Meesho', 
            description: 'Reseller platform integration and growth strategies',
            link:"/ecommerce-marketplaces-services"
        },
        { 
            title: 'Myntra', 
            description: 'Fashion eCommerce marketplace specialization',
            link:"/ecommerce-marketplaces-services"
        },
        { 
            title: 'Ajio', 
            description: 'Premium fashion retail marketplace services',
            link:"/ecommerce-marketplaces-services"
        },
    ];

    // MobileApp services data
    const mobileItems = [
        {
            title: 'iOS App Development',
            description: 'Custom iPhone and iPad app development using Swift and Objective-C',
            link: '/mobile-app-development'
        },
        {
            title: 'Android App Development',
            description: 'Native Android app development with Java and Kotlin',
            link: '/mobile-app-development'
        },
        {
            title: 'Cross-Platform Apps',
            description: 'Build apps with React Native or Flutter for both iOS and Android',
            link: '/mobile-app-development'
        },
        {
            title: 'UI/UX Design',
            description: 'Mobile-first design approach to deliver seamless user experiences',
            link: '/mobile-app-development'
        },
        {
            title: 'App Maintenance & Support',
            description: 'Ongoing app updates, bug fixes, and performance enhancements',
            link: '/mobile-app-development'
        },
       
    ];

    const items = showAll 
        ? [...webItems, ...digiItems, ...marketItems,...mobileItems] 
        : activeTab === 'web' 
            ? webItems 
            : activeTab === 'digi' 
                ? digiItems 
                : activeTab === 'market'
                    ? marketItems
                    : mobileItems;

    return (
        <nav className="navbar navbar-expand-md navbar-light flex items-center justify-between bg-blue-500 text-white">
            <div className="container">
                <div className="navbar-inner">
                    <div className="logo navbar-brand">
                        <Link href="/">
                            <Image src='/erateclogo.svg' alt='Eratec Solution Logo' width={160} height={70} />
                        </Link>
                    </div>
                    <div className="menu collapse navbar-collapse">
                        <div className="menu-items">
                            <Link href={"/"}>Home </Link>
                            <Link href={"/about"}>About </Link>
                            <div
                                className="dropdown nav-item"
                                onMouseEnter={toggleDropdown}
                                onMouseLeave={toggleDropdown}
                            >
                                <div className="relative">
                                    <div 
                                        className="inline-block pb-2"
                                        onMouseEnter={() => setIsDropdownOpen(true)}
                                        onMouseLeave={() => setIsDropdownOpen(true)}
                                    >
                                        <button className="dropdown-button nav-link flex items-center">
                                            <Link href={"/services"}>Services</Link>
                                            <svg 
                                                xmlns="http://www.w3.org/2000/svg" 
                                                className="dropdown-icon" 
                                                viewBox="0 0 20 20" 
                                                fill="currentColor"
                                            >
                                                <path fillRule="evenodd" d="M10 3a1 1 0 01.707.293l5 5a1 1 0 11-1.414 1.414L10 5.414 5.707 9.707A1 1 0 114.293 8.293l5-5A1 1 0 0110 3z" clipRule="evenodd" />
                                            </svg>
                                        </button>
                                    </div>

                                    {isDropdownOpen && (
                                        <div className="container"><div className="absolute left-[-355px] w-full min-w-[1000px] bg-white shadow-2xl rounded-md z-50 mt-0">
                                            <div className="ServicesTab w-full flex">
                                                <div className="w-64 bg-purple-600 border-gray-300">
                                                    <div
                                                        onClick={() => setActiveTab('web')}
                                                        className={`p-4 cursor-pointer group transition-colors ${
                                                            activeTab === 'web' ? 'bg-white border-blue-200' : 'hover:bg-purple-500'
                                                        }`}
                                                    >
                                                        <div className="flex items-center justify-between">
                                                            <div className="flex items-center gap-3">
                                                                <FiHome className={`w-5 h-5 ${
                                                                    activeTab === 'web' ? 'text-purple-700' : 'text-white group-hover:text-purple-200'
                                                                }`} />
                                                                <h3 className={`text-[16px] font-semibold ${
                                                                    activeTab === 'web' ? 'text-purple-900' : 'text-white group-hover:text-purple-200'
                                                                }`}>
                                                                    Website Development
                                                                </h3>
                                                            </div>
                                                            <svg className={`w-4 h-4 transition-transform ${
                                                                activeTab === 'web' ? 'text-purple-700 rotate-0' : 'text-white -rotate-90 group-hover:text-purple-200'
                                                            }`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                                            </svg>
                                                        </div>
                                                    </div>
                                                    
                                                    <div
                                                        onClick={() => setActiveTab('digi')}
                                                        className={`p-4 cursor-pointer group transition-colors ${
                                                            activeTab === 'digi' ? 'bg-white border-blue-200' : 'hover:bg-purple-500'
                                                        }`}
                                                    >
                                                        <div className="flex items-center justify-between">
                                                            <div className="flex items-center gap-3">
                                                                <FiTrendingUp className={`w-5 h-5 ${
                                                                    activeTab === 'digi' ? 'text-purple-700' : 'text-white group-hover:text-purple-200'
                                                                }`} />
                                                                <h3 className={`text-[16px] font-semibold ${
                                                                    activeTab === 'digi' ? 'text-purple-900' : 'text-white group-hover:text-purple-200'
                                                                }`}>
                                                                    Digital Marketing
                                                                </h3>
                                                            </div>
                                                            <svg className={`w-4 h-4 transition-transform ${
                                                                activeTab === 'digi' ? 'text-purple-700 rotate-0' : 'text-white -rotate-90 group-hover:text-purple-200'
                                                            }`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                                            </svg>
                                                        </div>
                                                    </div>

                                                    <div
                                                        onClick={() => setActiveTab('market')}
                                                        className={`p-4 cursor-pointer group transition-colors ${
                                                            activeTab === 'market' ? 'bg-white border-blue-200' : 'hover:bg-purple-500'
                                                        }`}
                                                    >
                                                        <div className="flex items-center justify-between">
                                                            <div className="flex items-center gap-3">
                                                                <FiShoppingCart className={`w-5 h-5 ${
                                                                    activeTab === 'market' ? 'text-purple-700' : 'text-white group-hover:text-purple-200'
                                                                }`} />
                                                                <h3 className={`text-[16px] font-semibold ${
                                                                    activeTab === 'market' ? 'text-purple-900' : 'text-white group-hover:text-purple-200'
                                                                }`}>
                                                                    Marketplace Services
                                                                </h3>
                                                            </div>
                                                            <svg className={`w-4 h-4 transition-transform ${
                                                                activeTab === 'market' ? 'text-purple-700 rotate-0' : 'text-white -rotate-90 group-hover:text-purple-200'
                                                            }`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                                            </svg>
                                                        </div>
                                                    </div>

                                                    <div
                                                        onClick={() => setActiveTab('mobile')}
                                                        className={`p-4 cursor-pointer group transition-colors ${
                                                            activeTab === 'mobile' ? 'bg-white border-blue-200' : 'hover:bg-purple-500'
                                                        }`}
                                                    >
                                                        <div className="flex items-center justify-between">
                                                            <div className="flex items-center gap-3">
                                                                <FiSmartphone
                                                                    className={`w-5 h-6 ${
                                                                        activeTab === 'mobile' ? 'text-purple-700' : 'text-white group-hover:text-purple-200'
                                                                    }`}
                                                                />
                                                                <h3 className={`text-[16px] font-semibold ${
                                                                    activeTab === 'mobile' ? 'text-purple-900' : 'text-white group-hover:text-purple-200'
                                                                }`}>
                                                                MobileApp Development
                                                                </h3>
                                                            </div>
                                                            <svg className={`w-4 h-4 transition-transform ${
                                                                activeTab === 'mobile' ? 'text-purple-700 rotate-0' : 'text-white -rotate-90 group-hover:text-purple-200'
                                                            }`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                                            </svg>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="flex-1">
                                                    <div className="grid grid-cols-3 pb-3 pt-3">
                                                        {items.slice(0, 9).map((item, index) => (
                                                            // <Link key={index} href={item.link} className="block">
                                                            <Link key={index} href={item.link} className="block cursor-pointer">
                                                            <div key={index} className="border-gray-200 p-3 hover:shadow-md transition-all hover:border-blue-300">
                                                                <h4 className="text-[13px] font-semibold" style={{ color: '#592693' }}>
                                                                    {item.title}
                                                                </h4>
                                                                <p className="text-[11px] leading-tight text-gray-600">
                                                                    {item.description}
                                                                </p>
                                                                
                                                            </div></Link>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div></div>
                                    )}     
                                </div>
                            </div>
                            <Link href={"/portfolio"}>Portfolio </Link>
                            <Link href={"/contact"}>Contact</Link>
                        </div>
                    </div>

                    <div className="others-option">
                        <Link className="btn btn-light" href="mailto:sales@eratecsolution.com">
                            <svg 
                                xmlns="http://www.w3.org/2000/svg" 
                                width="24" 
                                height="24" 
                                margin-right="3px"
                                viewBox="0 0 24 24" 
                                fill="none" 
                                stroke="currentColor" 
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                                <polyline points="22,6 12,13 2,6"></polyline>
                            </svg>
                            <span className='ml-2'>
                                sales@eratecsolution.com
                            </span>
                        </Link>

                        <Link className="btn btn-primary" href="tel:8802133490 ">
                            <svg 
                                xmlns="http://www.w3.org/2000/svg" 
                                width="20" 
                                height="20" 
                                viewBox="0 0 24 24" 
                                fill="none" 
                                stroke="currentColor" 
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                style={{marginRight:"5px"}}
                            >
                                <path d="M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                            </svg>
                            <span className='ml-0'>
                                 +91 8802133490 
                            </span>
                        </Link>
                    </div>

                    <div className="menu-toggle" onClick={toggleMenu}>
                        <svg xmlns="http://www.w3.org/2000/svg" className="menu-icon" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            {isMenuOpen ? (
                                <>
                                    <line x1="18" y1="6" x2="6" y2="18" />
                                    <line x1="6" y1="6" x2="18" y2="18" />
                                </>
                            ) : (
                                <>
                                    <line x1="3" y1="6" x2="21" y2="6" />
                                    <line x1="3" y1="12" x2="21" y2="12" />
                                    <line x1="3" y1="18" x2="21" y2="18" />
                                </>
                            )}
                        </svg>
                    </div>
                </div>

                {/* Mobile Menu */}
                  {isMenuOpen && (
    <div className="mobile-menu">
        <Link href={'/'} onClick={toggleMenu}>Home</Link>
        <Link href={'/about'} onClick={toggleMenu}>About</Link>
        <div className="mobile-dropdown">
            <button 
                className="dropdown-button nav-link flex items-center justify-between w-full"
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            >
                <span>Services</span>
                <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    className={`dropdown-icon transform transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`} 
                    viewBox="0 0 20 20" 
                    fill="currentColor"
                    width="16"
                    height="16"
                >
                    <path fillRule="evenodd" d="M10 3a1 1 0 01.707.293l5 5a1 1 0 11-1.414 1.414L10 5.414 5.707 9.707A1 1 0 114.293 8.293l5-5A1 1 0 0110 3z" clipRule="evenodd" />
                </svg>
            </button>
            {isDropdownOpen && (
                <div className="mobile-dropdown-content">
                    <div className="mobile-dropdown-section">
                        <div 
                            onClick={() => setActiveTab(activeTab === 'web' ? null : 'web')} 
                            className="mobile-dropdown-header flex justify-between items-center"
                        >
                            <span>Website Development</span>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className={`transform transition-transform ${activeTab === 'web' ? 'rotate-180' : ''}`}
                                width="16"
                                height="16"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                            >
                                <path fillRule="evenodd" d="M10 3a1 1 0 01.707.293l5 5a1 1 0 11-1.414 1.414L10 5.414 5.707 9.707A1 1 0 114.293 8.293l5-5A1 1 0 0110 3z" clipRule="evenodd" />
                            </svg>
                        </div>
                        {activeTab === 'web' && webItems.map((item, index) => (
                            <Link key={index} href={item.link} onClick={toggleMenu} className="mobile-dropdown-item">
                                {item.title}
                            </Link>
                        ))}
                    </div>
                    <div className="mobile-dropdown-section">
                        <div 
                            onClick={() => setActiveTab(activeTab === 'digi' ? null : 'digi')} 
                            className="mobile-dropdown-header flex justify-between items-center"
                        >
                            <span>Digital Marketing</span>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className={`transform transition-transform ${activeTab === 'digi' ? 'rotate-180' : ''}`}
                                width="16"
                                height="16"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                            >
                                <path fillRule="evenodd" d="M10 3a1 1 0 01.707.293l5 5a1 1 0 11-1.414 1.414L10 5.414 5.707 9.707A1 1 0 114.293 8.293l5-5A1 1 0 0110 3z" clipRule="evenodd" />
                            </svg>
                        </div>
                        {activeTab === 'digi' && digiItems.map((item, index) => (
                            <Link key={index} href={item.link} onClick={toggleMenu} className="mobile-dropdown-item">
                                {item.title}
                            </Link>
                        ))}
                    </div>
                    <div className="mobile-dropdown-section">
                        <div 
                            onClick={() => setActiveTab(activeTab === 'market' ? null : 'market')} 
                            className="mobile-dropdown-header flex justify-between items-center"
                        >
                            <span>Marketplace Services</span>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className={`transform transition-transform ${activeTab === 'market' ? 'rotate-180' : ''}`}
                                width="16"
                                height="16"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                            >
                                <path fillRule="evenodd" d="M10 3a1 1 0 01.707.293l5 5a1 1 0 11-1.414 1.414L10 5.414 5.707 9.707A1 1 0 114.293 8.293l5-5A1 1 0 0110 3z" clipRule="evenodd" />
                            </svg>
                        </div>
                        {activeTab === 'market' && marketItems.map((item, index) => (
                            <Link key={index} href={item.link} onClick={toggleMenu} className="mobile-dropdown-item">
                                {item.title}
                            </Link>
                        ))}
                    </div>
                    <div className="mobile-dropdown-section">
                        <div 
                            onClick={() => setActiveTab(activeTab === 'mobile' ? null : 'mobile')} 
                            className="mobile-dropdown-header flex justify-between items-center"
                        >
                            <span>MobileApp Development</span>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className={`transform transition-transform ${activeTab === 'mobile' ? 'rotate-180' : ''}`}
                                width="16"
                                height="16"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                            >
                                <path fillRule="evenodd" d="M10 3a1 1 0 01.707.293l5 5a1 1 0 11-1.414 1.414L10 5.414 5.707 9.707A1 1 0 114.293 8.293l5-5A1 1 0 0110 3z" clipRule="evenodd" />
                            </svg>
                        </div>
                        {activeTab === 'mobile' && mobileItems.map((item, index) => (
                            <Link key={index} href={item.link} onClick={toggleMenu} className="mobile-dropdown-item">
                                {item.title}
                            </Link>
                        ))}
                    </div>
                </div>
            )}
        </div>
        <Link href={"/portfolio"} onClick={toggleMenu}>Portfolio</Link>
        <Link href={"/contact"} onClick={toggleMenu}>Contact</Link>
    </div>
)}

            </div>
        </nav>
    );
};

export default Navbar;